import { CallCenterAgentState } from '@/api/callcenter/dashboard';
import { useSetFeedPause } from '@/api/callcenter/dashboard/setFeedPause';
import { Alert } from '@/components/Elements/Alert/Alert';
import { Button } from '@/components/ui/elements/button';
import { describeIneligibility } from '@/features/callcenter/logic';

type EligibilityBannerProps = {
  agent: CallCenterAgentState | undefined;
};

// Alert only ships red/yellow/green/blue variants -- blue is the closest
// match to an "info" tone (green already reads as "success" elsewhere in the
// app) and yellow is the established "warning" color (see SendMessage.tsx).
const alertColorByTone = {
  info: 'blue',
  warning: 'yellow',
} as const;

export const EligibilityBanner = ({ agent }: EligibilityBannerProps) => {
  // Called unconditionally, before either early return, to satisfy the Rules
  // of Hooks -- the mutation itself only ever fires from the Resume click.
  const setFeedPause = useSetFeedPause();

  if (!agent) {
    return null;
  }

  const notice = describeIneligibility(agent);

  if (!notice) {
    return null;
  }

  return (
    <div data-testid="eligibility-banner">
      <Alert title={notice.title} color={alertColorByTone[notice.tone]} size="sm">
        {notice.body && <p>{notice.body}</p>}
        {notice.showResume && (
          <Button
            type="button"
            size="sm"
            variant="outline"
            className="mt-2"
            onClick={() => setFeedPause.mutate(false)}
          >
            Resume
          </Button>
        )}
      </Alert>
    </div>
  );
};
